<template>
  <v-app>
    <v-app-bar app color="primary" dark v-if="$route.name != 'landing'">
      <div class="d-flex align-center">{{$appConfig.app.name}}</div>
      <v-spacer></v-spacer>
      <v-btn v-if="!signedin && !checking_user_status && $route.name != 'signin'" to="/signin" text>
        <span class="mr-2">Sign In</span>
      </v-btn>
      <v-btn v-if="signedin && !checking_user_status" v-on:click="signOutClicked" text>
        <span class="mr-2">Sign Out</span>
      </v-btn>
    </v-app-bar>

    <v-content v-if="checking_user_status">
      <div class="text-center mt-8">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-content>

    <v-content v-if="!checking_user_status">
      <apple-add-to-home-screen-modal
        v-if="showAddToHomeScreenModalForApple && $route.name != 'landing'"
        class="apple-add-to-home-screen-modal"
        @close="closeAddToHomeScreenModalForApple(false)"
      >
      </apple-add-to-home-screen-modal>
      <div v-if="$route.name != 'landing'">
        <map-view v-show="$route.name == 'map'"/>
      </div>
      <router-view v-if="$route.name != 'map'" class="mb-12"/>
    </v-content>

    <v-bottom-navigation fixed grow v-if="$route.name != 'landing'">
      <v-btn value="find" to="/map">
        <span>Map</span>
        <v-icon>mdi-map-search</v-icon>
      </v-btn>

      <v-btn value="MyListings" to="/listings">
        <span>My Listings</span>
        <v-icon>mdi-table-large-plus</v-icon>
      </v-btn>

      <v-btn value="settings" to="/feedback">
        <span>Feedback</span>
        <v-icon>mdi-comment-quote-outline</v-icon>
      </v-btn>

      <v-btn value="about" to="/about">
        <span>About</span>
        <v-icon>mdi-information-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-snackbar v-model="updateExists" :timeout="0" >
      New version available
      <v-btn color="success" text @click="updateNow">Update</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import {firebase} from '@/firebaseInit.js'
import AppleAddToHomeScreenModal from '@/components/AppleAddToHomeScreenModal'
import mapView from '@/views/mapView'
import showPrompt from '@/check-apple-install-prompt.js'

export default {
  components: { AppleAddToHomeScreenModal, mapView },
  name: 'App',
  props: { },
  data: () => ({
    checking_user_status: true,
    signedin: false,
    user: null,
    showAddToHomeScreenModalForApple: showPrompt,
    refreshing: false,
    registration: null,
    updateExists: false,
  }),
  created() {
    document.querySelector('#static_about').style.display = 'none';
    firebase.auth().onAuthStateChanged(user => {
      this.signedin = !!user;
      this.user = user;
      this.checking_user_status = false;
    });
    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    );

    if (!navigator.serviceWorker) return;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!localStorage.getItem('hasPreviousSW')) {
        localStorage.setItem('hasPreviousSW', 'true');
        return;
      }
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  methods: {
    closeAddToHomeScreenModalForApple() {
      localStorage.setItem('addToHomeIosPromptLastDate', Date.now())
      this.showAddToHomeScreenModalForApple = false;
    },
    showRefreshUI (e) {
      this.registration = e.detail;
      this.updateExists = true;
    },
    updateNow() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) return;
      this.registration.waiting.postMessage('skipWaiting');
    },

    signOutClicked: function () {
      firebase.auth().signOut().then(() => {
        this.signedin = false;
        this.$router.push("/");
      })
    },
  }
};
</script>
